import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image, Spinner } from 'react-bootstrap';
import logoEmpresa from '../../assets/img/logoEmpresa.png';
import LabelVersao from '../../components/labelVersao';
import FormLoginNovo from '../../components/formLoginNovo';
import dadosAplicacao from '../../../package.json';
import './style.css';


export default function Login(props) {

    const [verifingApiLink, setVerifingApiLink] = useState(false);

    const basic_auth = window.basic_auth;
    const basic_password = window.basic_password;

    if (localStorage.getItem('AppVersion')) {
        if (localStorage.getItem('AppVersion') != dadosAplicacao.version) {
            localStorage.setItem('AppVersion', dadosAplicacao.version);
            window.location.reload(true);
        }
    } else {
        localStorage.setItem('AppVersion', dadosAplicacao.version);
        window.location.reload(true);
    }

    async function verificaLinks() {
        setVerifingApiLink(true);

        const auth = btoa(`${basic_auth}:${basic_password}`);

        try {
            const response = await fetch(
                window.url_NOVA_API + window.validar_Conexao,
                {
                    method: "GET",
                    headers: {
                        Authorization: `Basic ${auth}`,
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            console.log("API está acessível!");
        } catch (error) {
            console.error("API está fora do ar!", error);
        } finally {
            setVerifingApiLink(false);
        }
    }

    useEffect(() => {
        verificaLinks();
    }, []);

    if (verifingApiLink) {
        return (
            <div className="form-login" style={{ height: "100vh" }}>
                <Spinner animation="grow" variant="success" />
                <span className="ms-3">
                    Verificando conectividade com a API...
                </span>
            </div>
        );
    }

    return (
        <Container fluid className="form-login">
            <Row className="no-gutter">
                <div className="d-none d-md-flex col-md-4 col-lg-6 bg-image">
                    <div className="titulo-login">
                        <h4 className="h4-titulo">Bem-vindo ao</h4>
                        <h2 className="h2-titulo"><strong>PORTAL</strong> RC</h2>
                    </div>
                    <Container fluid className="text-center rodape-imagem">
                        <p className="mr-4">Copyright &copy; 2020 -
                            RC Consultoria em Soluções Inteligentes. Todos os direitos reservados.</p>
                    </Container>
                </div>
                <Col md={8} lg={6}>
                    <div className="login d-flex align-items-center py-4">
                        <Container>
                            <Row>
                                <Col md={9} lg={6} className="mx-auto">

                                    <Image src={logoEmpresa} id="logo-empresa" className="align-center" />

                                    <FormLoginNovo
                                        historico={props.history} />

                                    <div className="text-right">
                                        <LabelVersao />
                                    </div>

                                </Col>
                            </Row>
                        </Container>
                    </div>
                </Col>
            </Row>
        </Container >
    );
}